import { propType as StyledSystemPropType } from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import { useEffect, useState } from 'react';
import { colors } from '../../constants/colors';
import { Flex } from '../grid';
import { Icon } from '../icons';

const AnimationIcon = ({ disabled, wrapperSize, iconSize, checked, initialIcon, checkedIcon, ...otherProps }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    setTimeout(() => {
      setSelected(checked);
      setIsAnimating(false);
    }, 300);
  }, [checked]);

  return (
    <Flex
      display="block"
      as="button"
      justifyContent="center"
      alignItems="center"
      disabled={disabled}
      borderRadius="100%"
      aria-label={selected ? checkedIcon : initialIcon}
      cursor="pointer"
      boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.29)"
      pointerEvents={disabled ? 'none' : undefined}
      backgroundColor={disabled ? colors.grey300 : colors.white}
      size={wrapperSize}
      {...otherProps}
    >
      <AnimatedIcon
        className={isAnimating ? 'animating' : ''}
        name={selected ? checkedIcon : initialIcon}
        fill="black"
        size={iconSize}
      />
    </Flex>
  );
};

const animatingRotate = keyframes`
  0% {
    transform: rotate(0deg);
    opacity: 1;
  }

  100% {
    transform: rotate(90deg);
    opacity: 0;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(90deg);
    opacity: 0;
  }

  100% {
    transform: rotate(180deg);
    opacity: 1;
  }
`;

const AnimatedIcon = styled(Icon)`
  animation: ${rotate} 0.3s linear;
  &.animating {
    animation: ${animatingRotate} 0.3s linear;
  }
`;

AnimationIcon.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  wrapperSize: StyledSystemPropType,
  iconSize: StyledSystemPropType,
  initialIcon: PropTypes.string,
  checkedIcon: PropTypes.string,
};

AnimationIcon.defaultProps = {
  disabled: false,
  wrapperSize: { xs: '44px', md: '55px' },
  checked: false,
  iconSize: { xs: '18px', lg: '24px' },
  initialIcon: 'plus',
  checkedIcon: 'minus',
};

export { AnimationIcon };
